
  export default {
    name: 'Jobintro',
  }
  